module.exports = __webpack_public_path__ + "img/House_1.3729a271.jpg";